import { render, staticRenderFns } from "./LabelledHR.vue?vue&type=template&id=53dd62b4&scoped=true"
import script from "./LabelledHR.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelledHR.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LabelledHR.vue?vue&type=style&index=0&id=53dd62b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dd62b4",
  null
  
)

export default component.exports